import { useEffect, useState } from 'react';
import AboutBLS from '../../Components/AboutBLS/AboutBLS';
import Header from '../../Components/Header/Header';
import Services from '../../Components/Services/Services';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import Testimonials from '../../Components/Testimonials/Testimonials';
import Enquire from '../../Components/Enquire/Enquire';
import "./Home.css"
import FAQ from '../../Components/FAQ/FAQ';
import Footer from '../../Components/Footer/Footer';
import firebaseApp from '../../firebaseConfig';
import Navbar from '../../Components/Navbar/Navbar';

function Home() {
  const [cardData, setCardData] = useState([]);
  
  useEffect(() => {
    async function getCardData() {
      try {
        const db = getFirestore(firebaseApp);
        const querySnapshot = await getDocs(collection(db, "Services"));
        const data = querySnapshot.docs.map(doc => doc.data());
        setCardData(data);
      } catch (error) {
        console.error("Error fetching card data:", error);
      }
    }

    getCardData();
    
  }, []);

  useEffect(() => {
    
  }, [cardData]);

  return (
    <div className="home">
      
      <Header />


      <AboutBLS />
      <Testimonials/>
      <Services cardData={cardData} />
      <FAQ />
      <Enquire />
      <Footer main={true}/>
    </div>
  );
}

export default Home;
